import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import supabase from "../../supabaseClient";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MainView from "../../Components/Manager/MainView";
import WorkerMainView from "../../Components/Worker/WorkerMainView";
import moment from "moment";
import DriverMainView from "../../Components/Driver/DriverMainView";

function Home() {
    const navigate = useNavigate();
    const [isVerified, setIsVerified] = useState(null);

    // Główna funkcja pobierająca i od razu sprawdzająca warunki (brak wycieków)
    const fetchDataAndVerify = async (userId) => {
        // 1. Pobieramy TYLKO potrzebne kolumny z profiles
        const { data: profileData, error: profileError } = await supabase
            .from('profiles')
            .select('profile_type, id_configuration, isBlocked')
            .eq('id', userId)
            .single();

        if (profileError) {
            console.error(profileError);
            return;
        }

        if (profileData) {
            // Sprawdzenie blokady użytkownika
            if (profileData.isBlocked === 1) {
                SignOut('/NoAccessLicence'); // Lub inna ścieżka dla zablokowanych
                return;
            }

            // Sprawdzenie braku konfiguracji
            if (profileData.id_configuration === null) {
                navigate('/WaitingRoomForNewUser');
                return;
            }

            // Zapisujemy konfigurację w localStorage
            localStorage.setItem('idConfiguration', profileData.id_configuration);

            // 2. Pobieramy ważność licencji
            const { data: configData, error: configError } = await supabase
                .from('configurations')
                .select('validity_date')
                .eq('id', profileData.id_configuration)
                .single();

            if (configError) {
                console.error(configError);
            } else if (configData && configData.validity_date) {
                // Sprawdzanie licencji od razu tutaj, zamiast w osobnym useEffect
                const currentDate = moment();
                const licenseDate = moment(configData.validity_date, 'DD:MM:YYYY HH:mm');

                if (currentDate.isAfter(licenseDate)) {
                    console.log("Brak aktywnej licencji");
                    SignOut('/NoAccessLicence');
                    return;
                }
            }

            // Jeśli wszystko jest OK, wpuszczamy użytkownika (ustawiamy rolę)
            setIsVerified(profileData.profile_type);
        }
    };

    useEffect(() => {
        const userIdFromLocalStorage = localStorage.getItem('userIdFromLocalStorage');
        if (userIdFromLocalStorage === null) {
            navigate('/');
        } else {
            fetchDataAndVerify(userIdFromLocalStorage);
        }
    }, [navigate]);

    const SignOut = async (redirectPath = '/NoAccessLicence') => {
        localStorage.clear();
        const { error } = await supabase.auth.signOut();
        if (error) {
            console.error("Error with sign out");
        }
        navigate(redirectPath);
    };

    return (
        <div>
            {isVerified === 'manager' && <MainView />}
            {isVerified === 'worker' && <WorkerMainView />}
            {isVerified === 'driver' && <DriverMainView />}
            {isVerified === null && (
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <CircularProgress size={80} />
                </Box>
            )}
        </div>
    );
}

export default Home;